import { useContext } from "react";
import { FeatureFlagsContext } from "./FeatureFlagsProvider";
import { isFeatureEnabled } from "./featureFlags";

/**
 * The current tenant's feature flags, fetched once by FeatureFlagsProvider (no
 * per-consumer fetch). `isEnabled` treats an unknown flag as false. While the flags
 * are loading (or if neither Flagsmith nor the backup answers), everything is off — a
 * feature only turns on once one of them confirms it.
 */
export function useFeatureFlags() {
  const { flags, isLoading, refresh } = useContext(FeatureFlagsContext);
  return {
    flags,
    isLoading,
    isEnabled: (flag: string) => isFeatureEnabled(flags, flag),
    /** Re-read the flags from Flagsmith now (e.g. on entering a page that gates on them). */
    refresh,
  };
}

/** Convenience: is a single flag enabled for the current tenant? */
export function useFeatureFlag(flag: string): boolean {
  return useFeatureFlags().isEnabled(flag);
}
